type CurrencyDivisors = {
  [currencyCode: string]: number
}

export const CURRENCY_DIVISORS: CurrencyDivisors = {
  USD: 100,
  AUD: 100,
  JPY: 1,
  EUR: 100,
  GBP: 100,
  CAD: 100,
  CHF: 100,
  CNY: 100,
  SEK: 100,
  NZD: 100,
  MXN: 100,
  SGD: 100,
  HKD: 100,
  NOK: 100,
  KRW: 100,
  // add more currencies and their divisors here
}

export const formatMoney = (
  value: number | undefined | null,
  currency: string,
): string => {
  // if the value is null or undefined, return a dash
  if (value == null || value == undefined) return '-'

  const divisor = CURRENCY_DIVISORS[currency] || 100 // default to 100 if the currency is not found in the object

  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: currency,
  })

  return formatter.format(value / divisor)
}

export const formatMoneyNumber = (value: number, currency: string): number => {
  const divisor = CURRENCY_DIVISORS[currency] || 100 // default to 100 if the currency is not found in the object

  return value / divisor || 0
}

export const transformToLowestDenominator = (
  value: number,
  currency: string,
): number => {
  const divisor = CURRENCY_DIVISORS[currency] || 100 // default to 100 if the currency is not found in the object

  return value * divisor
}
